<template>
    <div class="stripe-account-chart" :class="{loading: loading}">
        <div class="row">
            <div class="col-xs-4 text-center" v-if="isFinite(metrics.sum_charge_cents)">
                <dl class="no-margin">
                    <dt>
                        Total Billed:
                    </dt>
                    <dd class="no-margin">
                        <h4 class="currency"
                            v-html="$options.filters.displayCurrencyCents(metrics.sum_charge_cents)"></h4>
                    </dd>
                </dl>
            </div>
            <div class="col-xs-4 text-center" v-if="isFinite(sumPaidCents)">
                <dl class="no-margin">
                    <dt>
                        Total Paid:
                    </dt>
                    <dd class="no-margin">
                        <h4 class="currency"
                            v-html="$options.filters.displayCurrencyCents(sumPaidCents)"></h4>
                    </dd>
                </dl>
            </div>
            <div class="col-xs-4 text-center" v-if="isFinite(metrics.sum_amount_remaining_cents)">
                <dl class="no-margin">
                    <dt>
                        Outstanding:
                    </dt>
                    <dd class="no-margin">
                        <h4 class="currency"
                            v-html="$options.filters.displayCurrencyCents(metrics.sum_amount_remaining_cents)"></h4>
                    </dd>
                </dl>
            </div>
        </div>

        <progress-bar v-if="isFinite(paidPercentage)">
            <progress-bar-stack v-tooltip="'Amount Paid'" v-model="paidPercentage" type="success" label
                                :label-text="paidPercentageLabel"/>
            <progress-bar-stack v-tooltip="'Amount Outstanding'" v-model="unpaidPercentage" type="danger" label
                                :label-text="unpaidPercentageLabel"/>
        </progress-bar>

        <div class="row" v-if="billingDateFrom && billingDateTo && billingDateFrom !== billingDateTo">
            <div class="col-xs-6 text-right"
                 v-if="billingDateFrom && billingDateTo && billingDateFrom !== billingDateTo">
                From: {{billingDateFrom}}
            </div>

            <div class="col-xs-6">
                To: {{billingDateTo}}
            </div>
        </div>

        <div class="text-center" v-else-if="billingDateFrom !== billingDateTo">
            <span v-if="billingDateFrom">From: {{billingDateFrom}}</span>
            <span v-if="billingDateTo">To: {{billingDateTo}}</span>
        </div>

        <div class="text-center" v-else>
            {{billingDateFrom}}
        </div>
    </div>
</template>

<script>
    const numeral = require( 'numeral' );

    export default {
        props: {
            stripeAccountId: {
                type: String,
                required: true
            },

            billingDateFrom: {
                type: String
            },

            billingDateTo: {
                type: String
            }
        },

        created(){
            this.init();
        },

        data(){
            return {
                loading: false,

                metrics: {}
            };
        },

        computed: {
            sumPaidCents(){
                if( _.isNumber( this.metrics.sum_amount_remaining_cents ) && _.isNumber( this.metrics.sum_charge_cents ) ){
                    return this.metrics.sum_charge_cents - this.metrics.sum_amount_remaining_cents;
                }
            },

            paidPercentage(){
                if( _.isNumber( this.sumPaidCents ) && _.isNumber( this.metrics.sum_charge_cents ) && this.metrics.sum_charge_cents !== 0 ){
                    return this.sumPaidCents / this.metrics.sum_charge_cents * 100;
                }
            },

            unpaidPercentage(){
                if( _.isNumber( this.paidPercentage ) ){
                    return 100 - this.paidPercentage;
                }
            },

            paidPercentageLabel(){
                if( _.isNumber( this.paidPercentage ) ){
                    let numeralValue = numeral( this.paidPercentage );

                    return numeralValue.format( '0.00' ) + '%';
                }
            },

            unpaidPercentageLabel(){
                if( _.isNumber( this.unpaidPercentage ) ){
                    let numeralValue = numeral( this.unpaidPercentage );

                    return numeralValue.format( '0.00' ) + '%';
                }
            }
        },

        methods: {
            init(){
                this.loading = true;

                return this.loadMetrics()
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            loadMetrics(){
                var url = '/api/stripeAccounts/' + this.stripeAccountId + '/metrics?';

                if( this.billingDateFrom ){
                    url += 'billing_date_from=' + this.billingDateFrom;
                }

                if( this.billingDateTo ){
                    url += 'billing_date_to=' + this.billingDateTo;
                }

                return axios.get( url )
                    .then( ( response ) => {
                        this.$set( this, 'metrics', response.data.Metrics );
                    } );
            },
        }
    }
</script>
